import React, { useEffect, useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { useAppSelector } from '@pkg/hooks';

import {
    ButtonWrapper,
    PromptArrow,
    PromptHeading,
    PromptSubheading,
    TextButton,
    TwitterPromptWrapper,
} from './styles';

interface Props {
    toggleOpen(): void;
    isMobile?: boolean;
    forceClose?: boolean;
}

export const LOCAL_STORAGE_TWITTER_PROMPT_SEEN = 'twitterPromptSeen';

export const TwitterPromptModal = ({ toggleOpen, isMobile = false, forceClose }: Props) => {
    // TODO add back when required
    // const seenPrompt = localStorage.getItem(LOCAL_STORAGE_TWITTER_PROMPT_SEEN);
    const seenPrompt = true;
    const user = useAppSelector((state) => state.user);

    const hasTwitterData = user?.userClass?.user?.twitter_data;
    const [show, setShow] = useState(hasTwitterData ? false : !seenPrompt);
    const theme = useTheme();
    const { t } = useTranslation('yat_connect');

    const handleClose = () => {
        localStorage.setItem(LOCAL_STORAGE_TWITTER_PROMPT_SEEN, '1');
        setShow(false);
    };

    const handleShowMe = () => {
        toggleOpen();
        handleClose();
    };

    useEffect(() => {
        if (forceClose) {
            handleClose();
        }
    }, [forceClose]);

    if (!user) return null;

    return (
        <AnimatePresence>
            {show && (
                <TwitterPromptWrapper
                    $isMobile={isMobile}
                    exit={{ opacity: 0, translateY: '10px' }}
                    transition={{
                        duration: theme.transitions.speeds.fast,
                    }}
                >
                    <PromptArrow $isMobile={isMobile} />

                    <PromptHeading>{t('twitter_in_app_prompt_heading')}</PromptHeading>
                    <PromptSubheading>{t('twitter_in_app_prompt_subheading')}</PromptSubheading>
                    <ButtonWrapper>
                        <TextButton onClick={handleClose}>{t('twitter_in_app_prompt_got_it')}</TextButton>
                        <TextButton onClick={handleShowMe}>{t('twitter_in_app_prompt_show_me')}</TextButton>
                    </ButtonWrapper>
                </TwitterPromptWrapper>
            )}
        </AnimatePresence>
    );
};
